export const routes = Object.freeze({
  home: "/",
  services: "/services/",
  products: "/products/",
  about: "/about/",
  research: "/research/",
  contact: "/contact/",
  privacy: "/privacy-policy/",
  terms: "/terms-conditions-of-use/",
});

export const navigation = Object.freeze([
  { label: "Home", path: routes.home },
  { label: "Services", path: routes.services },
  { label: "Govern360", path: routes.products },
  { label: "About", path: routes.about },
  { label: "Research & Resources", path: routes.research },
  { label: "Contact", path: routes.contact },
]);

export const legacyAnchors = Object.freeze({
  aidecision: "stage-1",
  "decision-sprint": "stage-1",
  vantage: "stage-2",
  prioritisation: "stage-2",
  aicontrol: "stage-3",
  "ai-control-pack": "stage-3",
  delivery: "stage-4",
  roadtoprod: "stage-4",
});
